// extracted by mini-css-extract-plugin
module.exports = {"container":"_1HI0X"};